export const CONTACT_EMAIL = 'info@avalio.io';

export const LOGIN_URL =
  import.meta.env.VITE_NODE_ENV === 'development' ? 'http://localhost:2137/' : 'https://app.avalio.io/login';

export const FILM_EMBED_URL = 'https://iframe.mediadelivery.net/embed/339821/0b6506b5-e6f0-4d7d-9ee3-5ebf5ff0d645';

// Store links of the mobile app; while empty the badges show "coming soon"
export const APP_STORE_URL = null;
export const GOOGLE_PLAY_URL = null;

// Social profiles shown on partner pages; while empty the icons are not clickable
export const SOCIAL_LINKS = {
  facebook: null,
  instagram: null,
  linkedin: null
};
